"use strict";

require("./marko-namespace");

/**
 * Method is for internal usage only. This method
 * is invoked by code in a compiled Marko template and
 * it is used to create a new Template instance.
 * @private
 */
exports.t = function createTemplate(typeName) {
  return new Template(typeName);
};

function Template(typeName) {
  this.path = this.R_ = typeName;
}

var AsyncVDOMBuilder = require("./AsyncVDOMBuilder");
require("../createOut").be_(
  Template.prototype.createOut = function createOut(
  globalData,
  parent,
  parentOut)
  {
    return new AsyncVDOMBuilder(globalData, parent, parentOut);
  }
);

require("../renderable")(Template.prototype);